import React from "react";
import "../App.css";
import { BaseAddress } from "../projConst";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ReportIcon from "@material-ui/icons/Report";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { width } from "@material-ui/system";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#343433',
    color: theme.palette.common.white,
    opacity: 0.7,
    maxHeight: '2vh',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);


const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 200,
        maxWidth: 350,
      },    
}));

const ShowTotal = ({data}) => {
  const classes = useStyles();

  return (
      <div className="Show-total">
        <div className="Show-total-title">
           Итоги
        </div>
          <div className="Show-total-table">
            <TableContainer >
              <Table className={classes.table} aria-label="customized table">
                <TableHead>
                <TableRow>
                    <StyledTableCell>Тип</StyledTableCell>
                    <StyledTableCell align="right">План,ч.</StyledTableCell>
                    <StyledTableCell align="right">Факт,ч.</StyledTableCell>
                    <StyledTableCell align="right">&nbsp;%&nbsp;</StyledTableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {data.map((row) => (
                    <StyledTableRow key={row.vidp}>
                    <StyledTableCell component="th" scope="row">
                        {row.vidp}
                    </StyledTableCell>
                    <StyledTableCell align="right">{row.planh}</StyledTableCell>
                    <StyledTableCell align="right">{row.facth}</StyledTableCell>
                    <StyledTableCell align="right">{row.percent}</StyledTableCell>
                    </StyledTableRow>
                ))}
                </TableBody>
             </Table>
           </TableContainer>              
        </div>
      </div>
  );
};
export default ShowTotal;
